// @file TldrawHandles for TLDraw to replace DefaultHandles
// customize TldrawHandles to hide handles for shapes that user cannot edit
// This is currently only for arrow shape.
// mostly copied from TldrawHandles.tsx
import { useWhiteboardPermissionsStore } from '@@/pinia/whiteboard_permissions'
import type { TLHandlesProps } from '@tldraw/editor'
import { useEditor, useValue } from '@tldraw/editor'

export function TldrawHandles({ children }: TLHandlesProps): JSX.Element | null {
  const editor = useEditor()
  const whiteboardPermissionsStore = useWhiteboardPermissionsStore()

  const shouldDisplayHandles = useValue(
    'shouldDisplayHandles',
    () => {
      const onlySelectedShape = editor.getOnlySelectedShape()
      if (onlySelectedShape != null && !whiteboardPermissionsStore.canIEditShape(onlySelectedShape)) {
        return false
      }
      if (editor.isInAny('select.idle', 'select.pointing_handle', 'select.pointing_shape')) {
        return true
      }
      if (editor.isInAny('select.editing_shape')) {
        return onlySelectedShape != null && editor.isShapeOfType(onlySelectedShape, 'note')
      }
      return false
    },
    [editor],
  )

  if (!shouldDisplayHandles) return null

  return <svg className="tl-user-handles tl-overlays__item">{children}</svg>
}
